import React, { useRef, useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch } from 'react-redux';
import { fetchdata, fetchviewdata, ApproveData, RejectData, fetchviewDoc } from '../reduxactions/adminrsactions/AdViewDonorActions';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { GFNButton } from '../ui/GFNButton';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Message } from 'primereact/message';

export const AdminViewDonor = () => {

  const uid = window.sessionStorage.getItem('uid');
  const [globalFilter, setGlobalFilter] = useState('');

  const location = useLocation();

  const [queryParams, setQueryParams] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setQueryParams(params.get("donorID") as any);
  }, [location]);
  const { donorID } = useParams();
  console.log('Row ID:', donorID);
  const dispatch = useDispatch()
  const data = useSelector((state: RootState) => state.addonordocument.data);
  const viewdata = useSelector((state: RootState) => state.addonordocument.viewdata);
  const rejectdata = useSelector((state: RootState) => state.addonordocument.rejectdata);
  const approvedata = useSelector((state: RootState) => state.addonordocument.approvedata);
  const docdata = useSelector((state: RootState) => state.addonordocument.docdata);
  const toast = useRef(approvedata);
  const toast1 = useRef(rejectdata);

  const Closebutton = async () => {

    setApproveConfirmation(false);


  }
  //To get data
  const fetchDataAsync = async () => {
    try {
      await dispatch(fetchdata(donorID) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchDataViewAsync = async () => {
    try {
      await dispatch(fetchviewdata(donorID) as any);
    } catch (error) {
      console.error('Error fetching data', error)
    }
  }
  // To get data
  useEffectOnce(() => {
    fetchDataAsync();
    fetchDataViewAsync();

  }, [dispatch]);

  const [approveConfirmation, setApproveConfirmation] = useState(false);

  // });
  const Approve = (response: any) => {
    appData.current = { id: response.donorID }


    setApproveConfirmation(true);
  };
  const appData = useRef({ id: '' })

  const confirmApprove = async () => {
    try {
      await dispatch(ApproveData(donorID) as any);
      toast.current.show({ severity: 'success', summary: 'Approved Successfully', life: 3000 })
      setApproveConfirmation(false);
      setTimeout(() => {
        window.location.reload();
      }, 3000);


    } catch (error) {
      console.error('Error approving :', error);
    }

    fetchDataAsync();

  };
  const [rejectConfirmation, setRejectConfirmation] = useState(false);
  const [rejData, setRejecteData] = useState({
    id: '',

  });
  const Reject = (response: any) => {
    setRejecteData({
      id: response.donorID

    });
    setRejectConfirmation(true);
  };
  const confirmReject = async () => {
    const { id } = rejData;
    try {
      await dispatch(RejectData(donorID) as any);
      toast.current.show({ severity: 'success', summary: 'success', detail: 'Rejected Succesfully', life: 3000 })
      setRejectConfirmation(false);
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } catch (error) {
      console.error('Error while rejecting', error);
    }

    fetchDataAsync();

  };
  const [acceptfield, setfield] = useState(false);
  const [docData, setDocData] = useState({
    docid: '',
  });
  const viewDoc = (response: any) => {
    setDocData({
      docid: response.DocID

    });
    setfield(true);
    fetchdocdata(response.DocID);
  };
  const cancelfield = () => {
    setfield(false);
    dispatch({ type: 'EMPTY_DOC_DATA' });
  }
  //To assign data 

  const { docid } = docData;
  const fetchdocdata = async (docid: any) => {
    // const { docid } = docData;
    try {
      await dispatch(fetchviewDoc(docid) as any);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/adminviewdonors.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };
  return (
    <div className="admin-layout-container">
      <div className="row">
        <div className="main-content">
          {/* <div className="col-16" style={{ textAlign: "right" }}>
            <a
              title="help"
              onClick={(e) => openWindow(e, IUrl)}
              style={{

                color: "blue",
                fontSize: 15, cursor: "pointer"
              }}
            >Help for this Page &nbsp;
              <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

            </a>
          </div> */}
          <section className="app-page-header">
              <div>
                <h1 className="app-page-title">View Donors</h1>
              </div>
              <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                Help for this Page
                <i className="pi pi-question-circle"></i>
              </a>
            </section>
          <div className="content-wrapper mt-4">
            {viewdata.map((response: any) =>
              <section className="content">
                <Card title="">
                  <Panel header="Donor Information">
                    <div className="grid">

                      <div className="col-12 md:col-12 lg:col-6">
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Donor Name :</strong>
                          <p className="text-muted">{response.firstname}</p>
                        </div>


                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Email :</strong>
                          <p className="text-muted">{response.email}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>License No :</strong>
                          <p className="text-muted">{response.idcard_no}</p>
                        </div>

                      </div>
                      <div className="col-12 md:col-12 lg:col-6">
                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Address :</strong>
                          <p className="text-muted">{response.address}</p>
                        </div>


                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Contact No :</strong>
                          <p className="text-muted">{response.phone}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Country :</strong>
                          <p className="text-muted">{response.CountryName}</p>
                        </div>

                        <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                          <strong style={{ marginRight: '10px' }}>Application Status :</strong>
                          <p className="text-muted">{response.status}</p>
                        </div>
                      </div>
                    </div>
                  </Panel>
                </Card>
              </section>
            )}
            <section className="content">
              <Card title="">
                <Panel header="Attachments">
                  <div className="grid">
                    <div className="col-12">
                      <div className="card card-primary">
                        <div className="card flex flex-wrap justify-content">
                          <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                          </span>
                        </div>
                        <DataTable value={data} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                          <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                          <Column field="doc_name" sortable header="Attachment Name"></Column>
                          <Column field="CreteDate" sortable header="Expiry Date"></Column>
                          <Column header="View" body={(rowData) => (
                            <>

                              <GFNButton icon="pi pi-eye" buttonType="primary" size="sm" tooltip="View" testId={`view-btn-${rowData.DocID}`} onClick={() => viewDoc(rowData)} />


                            </>
                          )} />
                        </DataTable>

                      </div>
                    </div>
                  </div>
                </Panel>
              </Card>
              <br></br>
              <div className='grid'>
                <div className='col-9'></div>
                <div className='col-3'>
                  {viewdata.map((response: any) => (
                    <>
                      {(response.status === 'Approved' || response.status === 'Applied') && (
                        <GFNButton
                          className="mr-1"
                          buttonType="danger"
                          testId="reject-btn"
                          label="Reject"
                          onClick={() => Reject(response)}
                        />
                      )}

                      {(response.status === 'Rejected' || response.status === 'Applied') && (
                        <GFNButton
                          className="mr-1"
                          buttonType="success"
                          testId="approve-btn"
                          label="Approve"
                          onClick={() => Approve(response)}
                        />
                      )}
                    </>
                  ))}
                </div>
              </div>
            </section>
          </div>
          {/*Approve DIALOG */}
          <Dialog header="Confirm Approve" data-testid="approve-dialog" style={{ width: '30vw' }} visible={approveConfirmation} onHide={() => setApproveConfirmation(false)}>
            <div>Are you sure you want to Approve this item?</div>
            <GFNButton label="Yes" icon="pi pi-check" testId="approve-yes-btn" className='mr-3 mt-4' buttonType="success" onClick={confirmApprove} />
            <GFNButton label="No" icon="pi pi-times" testId="approve-no-btn" onClick={Closebutton} className="mr-3 mt-4" buttonType="secondary" />
          </Dialog>
          {/*Reject DIALOG */}
          <Dialog header="Confirm Reject" style={{ width: '30vw' }} data-testid="reject-dialog"  visible={rejectConfirmation} onHide={() => setRejectConfirmation(false)}>
            <div>Are you sure you want to Reject this item?</div>
            <GFNButton label="Yes" icon="pi pi-check" testId="reject-yes-btn" className='mr-3 mt-4' buttonType="danger" onClick={confirmReject} />
            <GFNButton label="No" icon="pi pi-times" testId="reject-no-btn" onClick={Closebutton} className="mr-3 mt-4" buttonType="secondary" />
          </Dialog>
          <Dialog header="View" style={{ width: '50vw' }} visible={acceptfield} onHide={cancelfield}>
            <div className="modal-header">

            </div>
            <form>
              <div className="modal-body">
                {docdata.map((rowData: any, index: number) =>
                  <div key={index}>
                    {rowData.filetype === 'image' && <img src={rowData.displayfile} alt="Doc" width="100%" height="auto" />}

                  </div>
                )}
              </div>
               <GFNButton label="Close" testId="view-close-btn" onClick={cancelfield} className="mr-3" buttonType="secondary" />
            </form>
          </Dialog>
          <Toast ref={toast} >
            <Message severity="success" content={approvedata} />
          </Toast>
        </div>
      </div>
    </div>
  )
}
export default AdminViewDonor


